import { defaultFeature, useClient, useQuery } from '@weenat/client'
import { FeaturKey } from '@weenat/client/dist/FeatureToggle'
import { useOrgContext } from 'app/orgProvider'
import { useToggleFeature } from 'app/state'
import { getVersion } from 'app/utils'
import { isNil } from 'lodash-es'
import { useEffect } from 'react'

const enableRolloutDeployment = true

/**
 * Overrides the feature flags with data from ts-worker (for progressive rollout).
 */
export const useOverriddenFeatureFlags = () => {
  const client = useClient()
  const org = useOrgContext()
  const [, setLocalFlags] = useToggleFeature()

  const { data: serverFlags } = useQuery(
    client.orgFeatureToggle.activatedKeys({
      networkId: org.network?.id,
      version: getVersion(),
      orgId: org.id
    }),
    {
      enabled: enableRolloutDeployment
    }
  )

  useEffect(
    () => {
      if (enableRolloutDeployment) {
        let overriddenFeatures: Partial<Record<keyof FeaturKey, boolean>> = {}

        if (!isNil(serverFlags)) {
          // We iterate on local flags to ensure that we always show the most recent versions of the flags.
          overriddenFeatures = Object.keys(defaultFeature).reduce((acc, flag) => {
            const castedFlag = flag as FeaturKey
            if (serverFlags.includes(castedFlag)) {
              return { ...acc, [castedFlag]: true }
            }
            return acc
          }, overriddenFeatures)
        }

        setLocalFlags((prevFlags) => ({ ...prevFlags, ...overriddenFeatures }))
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [serverFlags]
  )
}
